var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankDetailsTitleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.536 0.125478L15.336 3.88707C15.5356 3.98572 15.7035 4.1375 15.8208 4.32537C15.9381 4.51324 16.0001 4.72976 16 4.95061V6.09097C16 6.63739 15.552 7.08086 15 7.08086H14.4V13.4162H15.2C15.4122 13.4162 15.6157 13.4996 15.7657 13.6481C15.9157 13.7966 16 13.9981 16 14.2081C16 14.4181 15.9157 14.6195 15.7657 14.7681C15.6157 14.9166 15.4122 15 15.2 15H0.8C0.587827 15 0.384344 14.9166 0.234315 14.7681C0.0842854 14.6195 0 14.4181 0 14.2081C0 13.9981 0.0842854 13.7966 0.234315 13.6481C0.384344 13.4996 0.587827 13.4162 0.8 13.4162H1.6V7.08086H1C0.448 7.08086 0 6.63739 0 6.09097V4.95061C0 4.53723 0.216 4.15711 0.5648 3.94171L7.4632 0.125478C7.62986 0.0429606 7.81365 0 8 0C8.18635 0 8.36934 0.0429606 8.536 0.125478ZM12 7.08086H4V13.4162H5.6V8.66469H7.2V13.4162H8.8V8.66469H10.4V13.4162H12V7.08086ZM8 3.12129C7.78783 3.12129 7.58434 3.20472 7.43431 3.35324C7.28429 3.50175 7.2 3.70317 7.2 3.9132C7.2 4.12323 7.28429 4.32466 7.43431 4.47317C7.58434 4.62168 7.78783 4.70512 8 4.70512C8.21217 4.70512 8.41566 4.62168 8.56569 4.47317C8.71571 4.32466 8.8 4.12323 8.8 3.9132C8.8 3.70317 8.71571 3.50175 8.56569 3.35324C8.41566 3.20472 8.21217 3.12129 8 3.12129Z",
    fill: "#C4A167"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankDetailsTitleIcon);
export default __webpack_public_path__ + "static/media/Bank_Details_Title_Icon.f9cf6a0575128fc8669c3828744eeb4c.svg";
export { ForwardRef as ReactComponent };